import { mmFetchWithResponse } from '../mmFetchWithResponse';

const baseUrl = 'api/fbm/v3/orders';

const fbmOrdersV3 = {
    getDeepDive: async (orderNum, fbmAccountName) => {
        const url = `${baseUrl}/deep-dive?orderNum=${encodeURIComponent(orderNum)}&fbmAccount=${fbmAccountName}`;
        return mmFetchWithResponse(url, { method: 'GET' });
    },
};

export { fbmOrdersV3 };
